module.exports = __webpack_public_path__ + "static/img/search.6925cd27.svg";